import { useEffect, useRef, useState } from 'react';
import { useThemeStore } from '@/stores/themeStore';

export function RabbitHoleTransition() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [showSkip, setShowSkip] = useState(false);
  const [videoError, setVideoError] = useState(false);
  // Video is always muted — audio comes from the MP3 only
  const VIDEO_MUTED = true;
  const { enterRabbitHole } = useThemeStore();

  useEffect(() => {
    // Show skip button after 3 seconds
    const timer = setTimeout(() => setShowSkip(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Start MP3 audio as soon as component mounts
    if (audioRef.current) {
      audioRef.current.volume = 0.7;
      audioRef.current.play().catch(() => {
        // Autoplay blocked — audio will just be silent
      });
    }
  }, []);

  useEffect(() => {
    // Fallback: If video fails to load, auto-proceed after 2 seconds
    if (videoError) {
      const timer = setTimeout(() => handleComplete(), 2000);
      return () => clearTimeout(timer);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoError]);

  const handleComplete = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    enterRabbitHole();
  };

  return (
    <div className="fixed inset-0 z-[100000] bg-black flex items-center justify-center">
      {/* MP3 audio plays independently — video is always muted */}
      <audio
        ref={audioRef}
        src="/sounds/dial-up-modem-02.mp3"
        loop={false}
      />

      {!videoError ? (
        <video
          ref={videoRef}
          src="/videos/intro2.mp4"
          autoPlay
          onEnded={handleComplete}
          onError={() => setVideoError(true)}
          className="w-full h-full object-cover"
          playsInline
          muted={VIDEO_MUTED}
        />
      ) : (
        <div className="text-white text-center">
          <p className="text-xl mb-4">Entering the Rabbit Hole...</p>
          <div className="animate-spin w-16 h-16 border-4 border-matrix-green border-t-transparent rounded-full mx-auto"></div>
        </div>
      )}

      {/* Skip — appears after 3s */}
      {showSkip && !videoError && (
        <button
          onClick={handleComplete}
          className="absolute bottom-8 right-8 win98-button px-4 py-2 text-black hover:bg-gray-300 transition-colors z-[100001]"
        >
          Skip Transition
        </button>
      )}
    </div>
  );
}
